import Observer from '../../common/scripts/observer';
import {Utils} from '../../common/scripts/utils';
import YandexMap from '../../components/yandex-map';

const observer = new Observer();

/**
 * Карта в блоке контакты
 */
const contactsMap = document.querySelector('.j-contacts-map');
const mapPointers = Array.from(document.querySelectorAll('.j-contacts-pin'));
const pointersList = document.querySelector('.j-contacts-pins');
const addressWrapper = document.querySelector('.j-contacts-addresses');
let isLoaded = false;

const initMap = () => {
    const ymaps = window.ymaps;

    ymaps.ready(() => {
        const yandexMap = new YandexMap(ymaps);

        yandexMap.init({
            wrapper                : contactsMap,
            cluster                : true,
            fullScreenControl      : true,
            customFullScreenControl: true,
            customZoomControl      : true
        });
    });
};

const initContactMap = () => {
    isLoaded = true;
    const ymaps = window.ymaps;

    if (ymaps) {
        initMap();
    } else {
        Utils.loadScript('https://api-maps.yandex.ru/2.1/?lang=ru_RU', initMap);
    }
};

const changeActivePoint = (target) => {
    const activePointer = pointersList.querySelector('.is-active');
    const activeAddress = addressWrapper.querySelector('.is-active');
    const pointer = pointersList.querySelector(`[data-target="${target}"]`);

    // Если имеется активный поинтер, то снимаем с него класс активного
    if (activePointer) {
        activePointer.classList.remove('is-active');
    }

    // Устанавливаем класс активного поинтера на нажатый
    pointer.classList.add('is-active');

    // Если есть область с описанием адресов , то изменяем активный адрес на тот что соответствует текущему поинтеру
    if (addressWrapper) {
        const newActiveAddress = addressWrapper.querySelector(`[data-tab="${target}"]`);

        if (activeAddress) {
            activeAddress.classList.remove('is-active');
        }

        if (newActiveAddress) {
            newActiveAddress.classList.add('is-active');
        }
    }
};


if (contactsMap) {
    if ('IntersectionObserver' in window) {
        const lazyMapObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    if (!isLoaded) {
                        initContactMap();
                    }
                }
            });
        }, {rootMargin: '0px 0px 1000px 0px'});

        if (Utils.isInViewport(contactsMap, window.innerHeight || document.documentElement.clientHeight)) {
            initContactMap();
        } else {
            lazyMapObserver.observe(contactsMap);
        }
    } else {
        initContactMap();
    }
}

if (mapPointers.length) {
    observer.subscribe('aboutMarkerClick', (target) => {
        const activePointer = mapPointers.filter((pointer) => {
            return pointer.classList.contains('is-active');
        });

        if (activePointer[0].dataset.target === target) {
            return;
        }

        changeActivePoint(target);
    });

    mapPointers.forEach((pointer) => {
        pointer.addEventListener('click', () => {
            if (pointer.classList.contains('is-active')) {
                return;
            }

            const target = pointer.dataset.target;

            changeActivePoint(target);

            observer.publish('contactsPointerClick', target);
        });
    });
}
